<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 43 40"
      fill="currentColor"
    >
      <path
        d="M12.2669 26.9547C11.6887 26.353 10.6762 26.2782 10.0153 26.78L9.9979 26.7688L8.50224 28.2644C8.17429 28.5914 7.99449 29.0276 7.99449 29.4914C7.97477 30.4255 8.79718 31.246 9.73023 31.2271C10.2734 31.2359 10.7572 30.9644 11.1115 30.5651L12.2669 29.4097C12.5091 29.1675 12.6715 28.8662 12.7389 28.5382C12.86 27.971 12.681 27.3627 12.2669 26.9547Z"
        fill="#currentCoor"
      />
      <path
        d="M8.10805 21.8709C7.43102 21.1937 6.33093 21.1944 5.65308 21.8709C5.49555 22.0292 4.52418 23 4.34438 23.1806C2.78303 24.8751 5.10294 27.1959 6.79832 25.6356C6.79832 25.6356 7.93417 24.4996 8.10805 24.3258C8.78549 23.6495 8.78549 22.5482 8.10805 21.8709Z"
        fill="#currentCoor"
      />
      <path
        d="M15.8178 30.9141C15.354 30.9141 14.9177 31.0949 14.5898 31.4228L13.2801 32.7326C13.2739 32.7387 13.2678 32.7448 13.2617 32.752C12.6054 33.4004 12.6152 34.5486 13.2801 35.1875C13.9574 35.8639 15.0587 35.8639 15.735 35.1875L17.0458 33.8768C18.1314 32.794 17.3511 30.9083 15.8178 30.9141Z"
        fill="#currentCoor"
      />
      <path
        d="M27.4659 11.6471C24.7861 13.3369 21.1931 13.0161 18.8607 10.6837L15.8244 7.64848L19.6136 3.85926C15.5438 -0.707918 8.3873 -0.997651 4.05519 3.36388C-0.300409 7.68985 -0.0211985 14.8379 4.53638 18.9089C7.85544 17.0539 11.9369 19.6449 11.6684 23.4245C13.8661 23.6621 15.7267 25.654 15.8274 27.8523C17.894 27.808 19.9469 29.3558 20.4503 31.3973C22.1708 30.9361 24.0991 31.5074 25.2774 32.8705L25.3122 32.8296C27.0204 33.8552 28.8277 31.7486 27.5393 30.2143L27.5424 30.2102C27.5158 30.1846 20.6433 23.3122 20.6433 23.3122C21.1834 22.7721 22.2703 21.6852 22.8102 21.1453L29.6306 27.9657C31.325 29.5267 33.6463 27.2053 32.0845 25.5107L25.2652 18.6903C25.8052 18.1503 26.8921 17.0634 27.4321 16.5234C28.9649 18.0562 32.6836 21.7751 34.2524 23.3438C34.8983 24.0167 36.0614 24.0164 36.7074 23.3438C37.3837 22.6665 37.3837 21.5652 36.7074 20.8889L27.4659 11.6471Z"
        fill="#currentCoor"
      />
      <path
        d="M39.5067 3.36392C35.3538 -0.787973 28.5967 -0.787973 24.4438 3.36392C23.6363 4.17192 20.9228 6.88608 20.1602 7.64862L21.0285 8.517C22.5385 10.027 24.9945 10.027 26.5034 8.517L27.5874 7.43306C28.1637 8.01569 38.7425 18.5764 39.0398 18.8947C43.5865 14.8221 43.8559 7.68427 39.5067 3.36392Z"
        fill="#currentCoor"
      />
      <path
        d="M22.899 34.8123C22.2215 34.1359 21.121 34.1351 20.444 34.8123L19.1343 36.122C18.4603 36.7681 18.4606 37.9308 19.1343 38.577C19.7813 39.2494 20.9426 39.249 21.5892 38.577L22.899 37.2673C23.5715 36.622 23.5715 35.456 22.899 34.8123Z"
        fill="#currentCoor"
      />
    </svg>
  </div>
</template>
